import { GridActionsCellItem, GridRowParams } from "@mui/x-data-grid"
import { useContext } from "react"
import { Button, Grid, Layout, Loader, LoaderContainer, Paper, Table } from "../../components"
import { AuthContext } from "../../contexts"
import DownloadIcon from '@mui/icons-material/Download';
import { useAPI } from "../../hooks";
import { formatDateTime, formatMoney } from "@bussola-viagens/utils";
import { Navigate } from "react-router-dom";
import { user } from "@bussola-viagens/database";

export const OffersPage = () => {
    const [offers] = useAPI(`/offer`)
    const [dowloadedFile, downloadFile] = useAPI({
        method: 'GET',
    }, {
        manual: true
    })

    if (offers.loading) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    return (
        <Layout>
            <Grid container p={1} justifyContent="center" spacing={1}>
                <Grid item xs={10}>
                    <Paper>
                        <Table 
                            columns={[
                                { field: 'created_at', flex: 1, type: 'dateTime', headerName: 'Data de Criação', valueGetter: (value) => new Date(value), valueFormatter: formatDateTime },
                                { field: 'creator', flex: 1, type: 'string', headerName: 'Autor', valueGetter: (value: user) => value?.name },
                                { field: 'buyer_name', flex: 1, type: 'string', headerName: 'Cliente' },
                                { field: 'has_flight', flex: 1, type: 'boolean', headerName: 'Voo' },
                                { field: 'has_hotel', flex: 1, type: 'boolean', headerName: 'Hotel' },
                                { field: 'payment_method', flex: 1, type: 'string', headerName: 'Forma de Pagamento' },
                                { field: 'final_price', flex: 1, type: 'number', align: 'left', headerAlign: 'left', headerName: 'Valor Final', valueFormatter: (value) => formatMoney(value) },
                                { field: 'actions', type: 'actions', getActions: (params: GridRowParams) => [
                                    <GridActionsCellItem 
                                        icon={<DownloadIcon />} 
                                        onClick={() => {
                                            downloadFile({
                                                url: `/file/${params.row.file_id}`,
                                                responseType: 'blob'
                                            }).then((res) => {
                                                if (res.status === 200) {
                                                    const blobUrl = URL.createObjectURL(res.data);

                                                    window.open(blobUrl, '_blank')
                                                }
                                            })
                                        }} 
                                        label="Fazer Download" 
                                    />
                                ] }
                            ]}
                            rows={offers.data || []}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Layout>
    )
}